// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1DiXU","item":"PaymentsMobile_item__3sTLi","label":"PaymentsMobile_label__1Jt50","amount":"PaymentsMobile_amount__SFOmA"};